import React from "react";
import { useLocation } from "react-router-dom";
import OTPForm from "src/components/OTPForm";

const OTPVerification = () => {
	const location = useLocation();
	const { email } = location.state || {}; // Retrieve email from state

	return (
		<div className="">
			<div className="pageTitle">
				<h1>OTP Verification Code</h1>
				<p>Enter the OTP that was sent to your email</p>
			</div>

			<OTPForm email={email} />
		</div>
	);
};

export default OTPVerification;
